import baseAPI from "../api/baseApi";
import { authHeader } from "../helpers/authHeader";

const getMerchantOfferPerformanceReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("district_id", data.district);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/offer-performance-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getMerchantOfferPerformanceReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("district_id", data.district);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/offer-performance-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getCustomerInteractionReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-interaction-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getCustomerInteractionReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-interaction-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};


const getMerchantLoyaltyProgramReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("loyalty_type", data.loyalty_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/loyalty-program-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getMerchantLoyaltyProgramReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("loyalty_type", data.loyalty_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/loyalty-program-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getMerchantTransactionReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-transaction-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getMerchantTransactionReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-transaction-report-merchant`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchOfferPerformanceReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("district_id", data.district);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/offer-performance-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchOfferPerformanceReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("district_id", data.district);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/offer-performance-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchCustomerInteractionReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-interaction-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchCustomerInteractionReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-interaction-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchLoyaltyProgramReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("loyalty_type", data.loyalty_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(`/loyalty-program-report-branch`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchLoyaltyProgramReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("loyalty_type", data.loyalty_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(`/loyalty-program-report-branch`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchTransactionReport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-transaction-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const getBranchTransactionReportExport = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);
    formdata.append("category_id", data.category);
    formdata.append("discount_type", data.discount_type);
    formdata.append("page", data.page);

    const res = await baseAPI.post(
      `/customer-transaction-report-branch`,
      formdata,
      {
        headers: authHeader(),
      }
    );
    return res;
  } catch (error) {
    console.log(error);
  }
};

const ReportsService = {
  getCustomerInteractionReport,
  getMerchantTransactionReport,
  getMerchantLoyaltyProgramReport,
  getMerchantOfferPerformanceReport,
  getBranchOfferPerformanceReport,
  getBranchCustomerInteractionReport,
  getBranchLoyaltyProgramReport,
  getMerchantOfferPerformanceReportExport,
  getBranchTransactionReport,
  getBranchTransactionReportExport,
  getBranchLoyaltyProgramReportExport,
  getBranchCustomerInteractionReportExport,
  getBranchOfferPerformanceReportExport,
  getMerchantTransactionReportExport,
  getMerchantLoyaltyProgramReportExport,
  getCustomerInteractionReportExport,
};

export default ReportsService;
